export const SPORT_COLORS = {
  Run: '#ff7a00',
  TrailRun: '#ff8c1a',
  Ride: '#27ae60',
  Swim: '#2f80ed',
  Walk: '#9b51e0',
  Hike: '#9b51e0', // purple
  Workout: '#e377c2',
  Elliptical: '#7f7f7f',
  Golf: '#bcbd22',
  Default: '#d0d0d0',
}
